<template>
  <div class="adviceBtn" @click="goAdvice()" >
    <span class="iconfont icon-draft-fill"></span>
    <span class="txt_tip">意见反馈</span>
    <!-- <em>意见反馈</em> -->
  </div>
</template>

<script>
export default {
  name: 'adviceBtn',
  props:["detailOne"],
  computed:{
    type(){
      let path=this.$route.path;
      if(path.indexOf("artist")>=0){
        return '人才库'
      }
      if(path.indexOf("program")>=0){
        return '节目库'
      }
      if(path.indexOf("thematic")>=0){
        return "专题库"
      }
      if(path.indexOf("activity")>=0){
        return "活动库"
      }
    }
  },
  methods: {
    goAdviceOld(){
     let link = this.$router.resolve({
       path:'/advice',
       query:{
         name:this.detailOne.name,
         id:this.detailOne.id,
         source:this.type
       }
     });
     window.open(link.href,'_blank');
    },
    goAdvice(){
     let link = this.$router.resolve({
       path:'/advice',
     });
     window.open(link.href,'_blank');
    }
  },
}
</script>